<template>
    <div id="menuCartContainer">
        <div id="menuCart" v-on:click="toggleCart">
            View cart
            <i class="fa fa-shopping-cart"></i>
            <span class="badge">{{Items.length}}</span>
        </div>
        <div id="cartItemsContainer" class="cartItemsContainer">
            <div v-for="item in Items" :key="item.id + '-' + item.productModifiers.map(m => m.choices.map(mo => mo.name))" data-sku="@item.SKU">
                <div v-if="item.imageURL" class="img-container">
                    <img :src="item.imageURL">
                </div>
                <div v-else class="img"></div>
                <h5>{{item.name}}</h5>
                <div class="badge-container">
                    <span class="badge">{{item.quantity}}</span>
                </div>
                <small>{{item.productModifiers.map(m => m.choices.map(mo => mo.name)).join(", ")}}</small>
                <h6 class="product-price" :data-price="item.price" :data-tax="item.tax">{{item.total.toFixed(2)}}</h6>
            </div>
            <div class="cartTotal text-right">
                <span>Total: {{Total.toFixed(2)}}</span>
            </div>
            <div class="viewCart">
                <router-link to="cart" class="btn btn-sm btn-primary center"  :style="{ 'background-color': accentColor }">View Cart</router-link>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        watch: {
            $route() {
            }
        },
        data() {
            return {
                Items: [],
                Total : 0
            };
        },
        methods: {
            toggleCart(){
                var nav = document.getElementsByClassName('cartItemsContainer');
                if(nav.length > 0){
                    if (nav[0].style.display == 'block')
                        nav[0].style.display = 'none'
                    else
                        nav[0].style.display = 'block'
                }
            },
            populate(data){
                this.Items = data.products;
                this.Total = data.total;
                
                if(data.products && data.products.length > 0)
                    this.$hasItemsInCart = true;
                else
                    this.$hasItemsInCart = false;
            }
        },
        created() {
            var _self = this;

            if(localStorage.cartGuid != null && localStorage.franchiseID != null)
            {
                var data = {
                    FranchiseID: localStorage.franchiseID,
                    GUID: localStorage.cartGuid
                }
                _self.$ooApi.orders.cart.v1(data).then(function (result) {
                    _self.populate(result.data);
                })
            }
        },
        computed: {
            accentColor: function () {
              return this.$franchiseAccentColor;
            }
        }
    };
</script>
<!-- Styles -->
<style scoped>
/* BANNER */
.banner-container {
    position: relative;
    text-align: center;
}
.badge{
        background-color: #c30000 !important;
        font-size: 10px !important;
}
</style>